export const handleKeyDown = (
	event: React.KeyboardEvent,
	status: string,
	exceptions: boolean,
	handleCardClick: (status: string, exceptions: boolean) => void,
) => {
	if (event.key === "Enter" || event.key === " ") {
		event.preventDefault();
		handleCardClick(status, exceptions);
	}
};

export const useKeyDown = (
	handleCardClick: (status: string, exceptions: boolean) => void,
) => {
	return {
		handleKeyDown: (
			event: React.KeyboardEvent,
			status: string,
			exceptions: boolean,
		) => handleKeyDown(event, status, exceptions, handleCardClick),
	};
};
